export default __webpack_public_path__ + "static/media/phonebooth_closeUp_mobile.da568abc.webp";